import { render } from "./EmptySpace.vue?vue&type=template&id=e93b77e4"
import script from "./EmptySpace.vue?vue&type=script&lang=js"
export * from "./EmptySpace.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__